import * as uuid from "uuid";

import { Renderable3 } from "../../rendering/threejs/primitives/renderable3";
import { HasTouchPrimitive } from "../../inputs/primitives/i-has-touch-primitive";
import { SurfaceService } from "../surface.service";
import { TouchPrimitive } from "../../inputs/primitives/touch-primitive";
import { Rect, RectConstructor } from "../../primitives/rect";
import { Container, Graphics } from "pixi.js";
import {Vector2} from "three";

let DrawableCallback: (
  stage: Container,
  graphics: Graphics,
  timeDelta: number,
  surface: Surface,
) => void;
let UpdateCallback: (timeDelta: number, surface: Surface) => void;
let SetupCallback: (
  stage: Container,
  graphics: Graphics,
  surface: Surface,
) => void;

export class Surface extends Renderable3 implements HasTouchPrimitive {
  id = uuid.v4();
  __surfaceService: SurfaceService;
  __rendered = false;
  __debug = false;

  rect: TouchPrimitive;
  textureIsland: Rect;
  stage: Container;

  constructor(config: RectConstructor) {
    super();
    this.rect = new TouchPrimitive(config);
  }

  get x() {
    return this.mesh.position.x;
  }

  get y() {
    return this.mesh.position.y;
  }

  get width() {
    return this.rect.width;
  }

  get height() {
    return this.rect.height;
  }

  set x(pos) {
    this.mesh.position.x = pos;
    this.rect.x = pos;
    this.__surfaceService.updateSurfaceTextureIsland(this)
  }

  set y(pos) {
    this.mesh.position.y = pos;
    this.rect.y = pos;
    this.__surfaceService.updateSurfaceTextureIsland(this)
  }

  set width(pos) {
    // this.mesh.scale.x = pos;
    this.rect.width = pos;
  }


  set height(pos) {
    // this.mesh.scale.y = pos;
    this.rect.height = pos;
  }


  addPixiPrimitive(primitive: any) {
    primitive._surface = this;
    primitive._parent = this;

    this.stage.addChild(primitive.sprite);
    this.rect.addTouchChild(primitive.touchPrimitive);

    // Propagate surface to all children
    primitive.propagateSurface(this);
    primitive.onAddedToSurface(this);
    this.markForRender()
  }

  getTouchPrimitive(): TouchPrimitive {
    return this.rect;
  }

  markForRender() {
    this.__rendered = false;
  }

  destroy() {
    this.__surfaceService.__surfaces.delete(this.id);
    this.__surfaceService.three.removeFromScene(this.__mesh)
    this.destroy3()
    this.rect.removeFromParent()
    this.stage.removeFromParent()
    this.stage.destroy({ children: true })
  }

  debugGraphics: Graphics

  debugTouchHandlers() {
    if (this.debugGraphics) {
      this.stage.removeChild(this.debugGraphics);
      this.debugGraphics.destroy()
    }
    this.debugGraphics = new Graphics();
    this.debugGraphics.beginFill(this.niceColourMaker(0.5));
    this.debugGraphics.drawRect(this.rect.x, this.rect.y, this.rect.width, this.rect.height);
    this.debugGraphics.endFill();
    this.__drawTouchPrimitives(this.debugGraphics,new Vector2(0,0), [...this.rect.tp_children.values()])
    this.stage.addChild(this.debugGraphics);
  }

  __drawTouchPrimitives(graphics: Graphics,relativePos: Vector2, touchPrimitives: TouchPrimitive[]) {
      for (let touchPrimitive of touchPrimitives) {
        graphics.beginFill(this.niceColourMaker(0.5));
        graphics.drawRect(relativePos.x + touchPrimitive.x, relativePos.y + touchPrimitive.y, touchPrimitive.width, touchPrimitive.height);
        graphics.endFill();
        const newRelPos = relativePos.clone().add(new Vector2(touchPrimitive.x, touchPrimitive.y))
        for (let child of [...touchPrimitive.tp_children.values()]) {
          this.__drawTouchPrimitives(
              graphics,
              newRelPos,
              [child]
          )
        }
      }
  }


  niceColourMaker(alpha: number = 1) {
    const r = 0.1 + (Math.random() * 0.5 - 0.02);
    const g = 0.1 + (Math.random() * 0.5 - 0.02);
    const b = 0.1 + (Math.random() * 0.5 - 0.02);
    return [r, g, b, alpha];
  }
}
